import { useState, useEffect } from "react";
import { useAmiCommand } from "./use-ami-command";

interface LogSettings {
  debugLevel: number;
  verboseLevel: number;
  setDebugLevel: (level: number) => void;
  setVerboseLevel: (level: number) => void;
  isLoading: boolean;
}

export function useLogSettings(): LogSettings {
  const [debugLevel, setDebugLevel] = useState(0);
  const [verboseLevel, setVerboseLevel] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const amiCommand = useAmiCommand();

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const resp = await fetch("/api/logs/settings");
      const data = await resp.json();
      setDebugLevel(data.debug_level ?? 0);
      setVerboseLevel(data.verbose_level ?? 0);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetDebug = (level: number) => {
    setDebugLevel(level);
    amiCommand.mutate(`core set debug ${level}`);
  };

  const handleSetVerbose = (level: number) => {
    setVerboseLevel(level);
    amiCommand.mutate(`core set verbose ${level}`);
  };

  return {
    debugLevel,
    verboseLevel,
    setDebugLevel: handleSetDebug,
    setVerboseLevel: handleSetVerbose,
    isLoading,
  };
}